import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QrDetailsPage from "./pages/QrDetailsPage";


function App() {
  return (
    <Router>
      {/* <RedirectToUser /> Auto redirect on app start */}
      <Routes>
      <Route path="/user/:id?" element={<QrDetailsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
